import english from './en'

export const en = english
